import { isNumber } from 'lodash';
import { parseLayerId } from '@/framework';
import { Framework } from '@/framework/instance';
import { applyDifferentProps, getDifferentProps } from '@/utils/layer-kit';
import { IBaseMoveData, IBaseOperateFlag, ILayerProps } from '@/version-types';
import { IEditMessage } from '../../types';
import { OperateType } from '../../types/operate';
import { Collaborators } from '../collaborators';
import { Room } from '../room';

/**
 * 移动操作
 */
export class MoveOperate extends Framework {
    constructor(
        identity: string,
        private room: Room,
        private collaborators: Collaborators,
    ) {
        super(identity);
        this.room.onMessage(OperateType.Move, this.onReceiveMoveOperate.bind(this));
    }

    /** 发送选中图层事件 */
    send(args: IBaseOperateFlag, data: IBaseMoveData, oldLayer: ILayerProps | null) {
        if (oldLayer) {
            const newLayer = this.framework.getLayer(data.layerId, true);
            const diffInfo = getDifferentProps(newLayer, oldLayer);
            this.room.throttleSendToAll(OperateType.Move, [diffInfo, args.isEnd ? 1 : 0], args.isEnd);
            if (args.isEnd) {
                Object.keys(diffInfo).forEach((layerId) => {
                    this.room.syncBaseOperateAdapter.set(this.room.collaborators.getWsKey(), layerId);
                });
            }
        }
    }

    /** 收到选中图层事件回调 */
    private onReceiveMoveOperate({ fromWsMemberKey, data }: IEditMessage<[Record<string, any>, number]>) {
        const [diffInfo, isEnd] = data;
        const keys: string[] = [];
        Object.keys(diffInfo).forEach((layerId) => {
            keys.push(layerId);
            if (!isEnd) {
                const differentProps = diffInfo[layerId];
                const layer = this.framework.getLayer(layerId, true);
                if (!layer) return;
                applyDifferentProps(layer, differentProps, this.framework.getLayer(layerId));
                const { originIndex } = parseLayerId(layerId);
                if (isNumber(originIndex)) {
                    this.framework.stage.addOrUpdate(layer, false);
                    this.framework.setRerender(originIndex);
                }
            }
        });
        if (!isEnd) {
            this.framework.rerender();
        }
        keys.forEach((layerId) => {
            if (isEnd) {
                this.room.syncBaseOperateAdapter.set(fromWsMemberKey, layerId);
            } else {
                this.framework.operate.tryRefreshActiveLayer(layerId);
            }
        });
    }
}
